<template>
  <b-modal id="forms-modal" hide-footer>
    <b-form @submit.prevent="handleSubmit()">
      <b-form-group :label="$t('visit.chooseForm')">
        <b-form-select
          v-model="form.formId"
          :options="options"
          required
        ></b-form-select>
      </b-form-group>
      <b-form-group v-for="el in fields" :key="`form${el.id}`" :label="el.name">
        <b-form-textarea
          v-model="form.fields[el.id]"
          required
          rows="3"
          max-rows="100"
        ></b-form-textarea>
      </b-form-group>
      <b-button type="submit">{{ $t('visit.generate') }}</b-button>
      <template v-if="wybrany && wybrany.wyslijLink">
        <b-button class="ml-2" variant="outline-secondary" :disabled="wysylam" @click="wyslijLink('sms')">
          Wyślij SMS z linkiem
        </b-button>
        <b-button class="ml-2" variant="outline-secondary" :disabled="wysylam" @click="wyslijLink('mail')">
          Wyślij e-mail
        </b-button>
        <p class="mt-2 mb-0 small text-muted">
          Pacjent dostanie link do pełnej treści zgody i potwierdzi ją w telefonie. Zgoda trafi do kartoteki; przed zabiegiem
          pacjent i tak podpisuje wydruk.
        </p>
        <p v-if="wynikWysylki" class="mt-2 mb-0 small">{{ wynikWysylki }}</p>
      </template>
    </b-form>
  </b-modal>
</template>
<script>
import formsService from '@/services/forms'

export default {
  props: {
    forms: {
      type: Array,
      required: true
    }
  },
  computed: {
    wybrany() {
      return this.forms.find((el) => el.id === this.form.formId) || null
    },
    fields() {
      return this.wybrany ? this.wybrany.fields : []
    },
    options() {
      return this.forms.map((el) => ({
        text: el.name,
        value: el.id
      }))
    }
  },
  data() {
    return {
      form: {
        formId: 0,
        fields: {}
      },
      wysylam: false,
      wynikWysylki: ''
    }
  },
  watch: {
    'form.formId'() {
      this.wynikWysylki = ''
    }
  },
  methods: {
    handleSubmit() {
      this.$emit('send-form', this.form)
    },
    async wyslijLink(kanal) {
      this.wysylam = true
      this.wynikWysylki = ''
      try {
        const { data } = await formsService.sendLink({
          patientId: this.form.patientId,
          visitId: this.form.visitId,
          formId: this.form.formId,
          kanal
        })
        const czesc = data[kanal] || {}
        this.wynikWysylki = czesc.wyslany
          ? (kanal === 'sms' ? 'SMS wysłany' + (czesc.na ? ' na ' + czesc.na : '') : 'E-mail wysłany') + '. Link ważny 7 dni.'
          : 'Nie wysłano: ' + (czesc.powod || czesc.blad || 'brak odpowiedzi')
      } catch (e) {
        const msg = e && e.response && e.response.data && e.response.data.message
        this.wynikWysylki = 'Nie wysłano: ' + (msg || 'błąd połączenia')
      } finally {
        this.wysylam = false
      }
    }
  },
  mounted() {
    this.form.patientId = this.$route.params.id
    this.form.visitId = this.$route.params.visit
  }
}
</script>
